<template>
  <section>
    <!-- No error -->
    <b-row>
      <!-- Left content -->
      <b-col
        v-if="errorPage === false && (isRegisterAvailable || isRegisterAvailableSpecial)"
        lg="4"
        md="6"
        sm="12"
      >
        <b-overlay
          :show="isLoadingSomeContent"
          opacity="0.50"
          rounded="sm"
        >
          <was-student-choice @choice-selected="wasStudentOptionSelected = $event" />
        </b-overlay>

        <b-card class="text-center">
          <p>
            Por seguridad, este formulario caduca en <strong>30 minutos</strong>, porfavor, le pedimos complete los campos durante este intervalo de tiempo.
          </p>
          <p>
            Si el formulario se caduca, no se preocupe, vuelva a presionar el enlace que se encuentra en su correo electrónico.
          </p>
        </b-card>
      </b-col>

      <!-- Right content -->
      <b-col
        v-if="errorPage === false && (isRegisterAvailable || isRegisterAvailableSpecial)"
        lg="8"
        md="6"
        sm="12"
      >
        <b-overlay
          :show="isLoadingSomeContent"
          opacity="0.50"
          rounded="sm"
        >
          <b-card v-if="wasStudentOptionSelected === null">
            <p class="text-center m-0">
              Indícanos si ya cursaste alguna especialidad o diplomado en <strong>Campus Virtual</strong>.
            </p>
          </b-card>
          <section>
            <was-already-student
              v-if="wasStudentOptionSelected === true"
              :tbl="tbl"
              :nla="nla"
              :user-rol="userRol"
              :current-plan="plan"
              :success-preregister-process="successPreregisterProcess"
              :periodo="dataEspecialidad.periodo"
              @update-tbl="tbl = $event"
              @set-loader="isLoading.planData = $event"
            />

            <new-student
              v-if="wasStudentOptionSelected === false"
              :tbl="tbl"
              :nla="nla"
              :user-rol="userRol"
              :current-plan="plan"
              :success-preregister-process="successPreregisterProcess"
              :periodo="dataEspecialidad.periodo"
              @update-tbl="tbl = $event"
              @set-loader="isLoading.planData = $event"
            />
          </section>
        </b-overlay>
      </b-col>
    </b-row>

    <!-- Error -->
    <b-row v-if="errorPage === true">
      <b-col />
      <b-col lg="6">
        <b-alert
          variant="danger"
          show
        >
          <h4 class="alert-heading">
            Lamentamos las inconveniencias
          </h4>
          <div class="alert-body">
            <span>Algo extraño ha ocurrido, por favor intente nuevamente más tarde, si el error continúa, póngase en contacto con nuestro equipo de soporte.</span>
          </div>
        </b-alert>
      </b-col>
      <b-col />
    </b-row>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BAlert,
  BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { getTblNla, getData } from '@core/utils/http/general'
import { isObject, isEmptyObject, useRouter } from '@core/utils/utils'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
import {
  ref, computed, watch, onMounted, onUnmounted, getCurrentInstance,
} from '@vue/composition-api'

import WasStudentChoice from './components/pre-registro/WasStudentChoice.vue'
import WasAlreadyStudent from './components/pre-registro/WasAlreadyStudent.vue'
import NewStudent from './components/pre-registro/NewStudent.vue'

// let interval // INTERVALO PARA HACER REDIRECT DESPUÉS DE 45MIN SIN HACER SUBMIT

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BAlert,
    BOverlay,
    WasStudentChoice,
    WasAlreadyStudent,
    NewStudent,
  },
  directives: {
    Ripple,
  },
  setup() {
    const toast = useToast()
    const { route, router } = useRouter()
    const vm = getCurrentInstance().proxy
    const routeParams = route.value.params
    const TIME_TO_REDIRECT_BEFORE_POST = 1800000 // 30 minutes
    let interval = null
    const dataEspecialidad = ref({})
    const wasStudentOptionSelected = ref(null)
    const isShowingWasStudentOptionModal = ref(true)
    const plan = ref({})
    const isRegisterAvailableSpecial = ref(false)
    const counter = ref(1)
    const oldTbl = ref('')
    const tbl = ref('')
    const nla = ref('')
    const errorPage = ref(false)
    const isLoading = ref({
      session: false,
      planData: false,
      timestamps: false,
    })

    // Computed function to know if course data is available
    const isRegisterAvailable = computed(() => {
      const data = dataEspecialidad.value

      if (
        !data.calendario
        || !data.calendario.length
        || !isObject(data)
        || isEmptyObject(data)
      ) return false

      const currentDate = Math.floor(Date.now() / 1000)
      const { fechaIni, fechaFin } = data.calendario.find(item => item.tipo === parseInt(2, 10))

      if (currentDate >= fechaIni && currentDate <= fechaFin) return true

      return false
    })

    // Computed function to know if some loader is enabled
    const isLoadingSomeContent = computed(() => {
      const { session, planData, timestamps } = isLoading.value

      if (session || planData || timestamps) return true

      return false
    })

    // Check tbl each 45 min, interval redirect
    const intervalRedirect = () => {
      interval = setInterval(() => {
        if (tbl.value !== oldTbl.value) return

        toast({
          component: ToastificationContent,
          props: {
            title: 'Formulario caducado',
            text: 'El formulario de pre-registro ha expirado, ingrese nuevamente',
            icon: 'ClockIcon',
            variant: 'warning',
          },
        }, { timeout: 8000 })

        clearInterval(interval)
        router.push(`/detalle-especialidad/${routeParams.id}`)
      }, TIME_TO_REDIRECT_BEFORE_POST)
    }

    // Check session's data
    const checkSession = async ({ rolSelected, session }) => {
      try {
        isLoading.value.session = true
        const response = await getData({ action: 30, x: rolSelected, t: session })

        if (response.status !== 200) throw new Error(response.statusText)

        const { status, message } = response.data

        if (status !== 200) {
          isRegisterAvailableSpecial.value = false

          throw new Error(message)
        }

        isRegisterAvailableSpecial.value = true
        toast({
          component: ToastificationContent,
          props: {
            title: message,
            text: 'Formulario disponible por sesión',
            icon: 'UnlockIcon',
            variant: 'warning',
          },
        },
        { timeout: 8000 })
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error validating session',
            text: error.message,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        },
        { timeout: 8000 })
      } finally {
        isLoading.value.session = false
      }
    }

    // Get plan's data
    const loadPlanData = async () => {
      try {
        isLoading.value.planData = true
        const response = await getData({ action: 15 })

        if (response.status !== 200) throw new Error(response.statusText)

        const { status, message, planes } = response.data

        if (status !== 200) {
          dataEspecialidad.value = {}
          isRegisterAvailableSpecial.value = false

          throw new Error(message)
        }

        const currentPlan = planes.find(item => item.id === parseInt(routeParams.id, 10))
        dataEspecialidad.value = currentPlan
        plan.value.nombre = dataEspecialidad.value.nombre
      } catch (error) {
        dataEspecialidad.value = {}
        isRegisterAvailableSpecial.value = false

        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching data',
            text: error.message,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        },
        { timeout: 8000 })
      } finally {
        isLoading.value.planData = false
      }
    }

    // Fetching tbl and nla
    const getFormTimeAndCountParams = async () => {
      try {
        isLoading.value.timestamps = true
        const response = await getTblNla()

        if (response.status !== 200) throw new Error(response.statusText)

        const { status, message, data } = response.data

        if (status !== 200) throw new Error(message)

        tbl.value = data.tbl
        oldTbl.value = data.tbl
        nla.value = data.nla

        intervalRedirect()
        loadPlanData()
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Fetching timestamps',
            text: error.message,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        isLoading.value.timestamps = false
      }
    }

    // Display Swal component when success preregister was sended.
    const successPreregisterProcess = ({
      registerPath, controlEscolar, esEstudiante, userMail,
    }) => {
      const isStudentLabel = esEstudiante ? '<br /><br /><strong>Aviso:</strong> Este aspirante ya se encuentra registrado en el sistema Campus Virtual, por lo cual, el siguiente paso será capturar su documentación.' : ''

      let htmlContent = `Hemos enviado un correo <strong>para continuar con el  proceso de admisión</strong> a la cuenta <strong>${userMail}</strong>. Si no lo visualiza en su <strong>bandeja de entrada</strong>, le sugerimos revisar su bandeja de "No deseados" o carpeta <strong>SPAM</strong> y le suplicamos <strong>autorizar nuestro correo como seguro</strong>, ya que éste será nuestro medio de comunicación.${isStudentLabel}`
      let buttonText = 'De acuerdo; revisaré mi bandeja de correo electrónico.'
      let redirectPath = `/detalle-especialidad/${route.value.params.id}`

      if (controlEscolar) {
        htmlContent = `Hemos generado el pre registro de manera exitosa, presione el botón <strong>Continuar</strong> para seguir el proceso de inscripción.${isStudentLabel}`
        buttonText = 'Continuar'
        redirectPath = isStudentLabel ? `/detalle-especialidad/${route.value.params.id}` : `/registro/solicitud-admision/${registerPath}`
      }

      vm.$swal({
        title: '<strong>Pre registro exitoso</strong>',
        html: htmlContent,
        icon: 'success',
        showConfirmButton: true,
        buttonsStyling: false,
        confirmButtonText: buttonText,
        allowOutsideClick: false,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      }).then(() => {
        router.push(redirectPath)
      })
    }

    // On mounted
    onMounted(() => {
      const { id } = routeParams

      if (!id || isEmptyObject(routeParams)) {
        errorPage.value = true
        return
      }

      plan.value.id = parseInt(id, 10)
      getFormTimeAndCountParams()

      const { rolSelected, session } = store.state.cuenta

      if (session && session.token && rolSelected && rolSelected.id) checkSession({ rolSelected: rolSelected.id, session: session.token })
    })

    onUnmounted(() => {
      if (interval) clearInterval(interval)
    })

    watch(() => route.path, () => {
      if (interval) clearInterval(interval)
    })

    return {
      dataEspecialidad,
      wasStudentOptionSelected,
      successPreregisterProcess,
      isShowingWasStudentOptionModal,
      plan,
      isRegisterAvailableSpecial,
      counter,
      tbl,
      oldTbl,
      nla,
      isLoadingSomeContent,
      isLoading,
      errorPage,
      userRol: store.state.cuenta.rolSelected,

      isRegisterAvailable,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
